import http from '~/common/http'
export default {
    // 新增销售渠道
    create(params) {
        return http.post('/api/sales-leads-channel/create', params);
    },

    //编辑线索渠道
    edit(params) {
        return http.put('/api/sales-leads-channel/update', params);
    },

    // 线索渠道筛选
    getList(params) {
        return http.get('/api/sales-leads-channel/index', {
            params: params
        });
    },

    // 线索渠道筛选
    getParentList(params) {
        return http.get('/api/sales-leads-channel/get-parent-list', {
            params: params
        });
    },

    // 线索渠道筛选
    getTreeList(params) {
        return http.get('/api/sales-leads-channel/get-tree-list', {
            params: params
        });
    },

    /**
     * 获取指定渠道信息-列表
     */
    getChannels(ids) {
        return http.post('/api/sales-leads-channel/get-channels', {ids: ids});
    },
}


// WEBPACK FOOTER //
// ./src/services/SaleChannel.js